// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AttributionRouteImport } from './routes/attribution'
import { Route as BenchmarkRouteImport } from './routes/benchmark'
import { Route as CampusRouteImport } from './routes/campus'
import { Route as CliAuthRouteImport } from './routes/cli-auth'
import { Route as CoachingRouteImport } from './routes/coaching'
import { Route as ConsultingRouteImport } from './routes/consulting'
import { Route as DesignRoomRouteImport } from './routes/design-room'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as FacilitatorRouteImport } from './routes/facilitator'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as HomeRouteImport } from './routes/home'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as MarketingRouteImport } from './routes/marketing'
import { Route as MulaiRouteImport } from './routes/mulai'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OtomatisRouteImport } from './routes/otomatis'
import { Route as PlanRouteImport } from './routes/plan'
import { Route as PlaybooksRouteImport } from './routes/playbooks'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PromptsRouteImport } from './routes/prompts'
import { Route as ReadinessRouteImport } from './routes/readiness'
import { Route as RoomRouteImport } from './routes/room'
import { Route as ServeRouteImport } from './routes/serve'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as VouchersRouteImport } from './routes/vouchers'
import { Route as ToolIdEditRouteImport } from './routes/$toolId.edit'
import { Route as AdminCampusRouteImport } from './routes/admin/campus'
import { Route as AdminChatRouteImport } from './routes/admin/chat'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as AdminPlansRouteImport } from './routes/admin/plans'
import { Route as AdminTinjauanRouteImport } from './routes/admin/tinjauan'
import { Route as AdminToolsRouteImport } from './routes/admin/tools'
import { Route as AdminTransactionsRouteImport } from './routes/admin/transactions'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminVouchersRouteImport } from './routes/admin/vouchers'
import { Route as ClientIndexRouteImport } from './routes/client/index'
import { Route as ClientPlanIdRouteImport } from './routes/client/$planId'
import { Route as CompareSlugRouteImport } from './routes/compare.$slug'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as PSlugRouteImport } from './routes/p/$slug'
import { Route as PlansPlanIdRouteImport } from './routes/plans/$planId'
import { Route as RTokenRouteImport } from './routes/r/$token'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as TemplatesSlugRouteImport } from './routes/templates/$slug'
import { Route as WorkspaceWorkspaceIdIndexRouteImport } from './routes/workspace/$workspaceId/index'
import { Route as WorkspaceWorkspaceIdViewRouteImport } from './routes/workspace/$workspaceId/$view'
import { Route as WorkspaceWorkspaceIdBangunRouteImport } from './routes/workspace/$workspaceId/bangun'
import { Route as WorkspaceWorkspaceIdBantuanRouteImport } from './routes/workspace/$workspaceId/bantuan'
import { Route as WorkspaceWorkspaceIdCostRouteImport } from './routes/workspace/$workspaceId/cost'
import { Route as WorkspaceWorkspaceIdSettingsRouteImport } from './routes/workspace/$workspaceId/settings'
import { Route as WorkspaceWorkspaceIdStudioRouteImport } from './routes/workspace/$workspaceId/studio'
import { Route as WorkspaceWorkspaceIdTerbitkanRouteImport } from './routes/workspace/$workspaceId/terbitkan'
import { Route as WorkspaceWorkspaceIdRoomIndexRouteImport } from './routes/workspace/$workspaceId/room/index'
import { Route as WorkspaceWorkspaceIdRoomRoomIdRouteImport } from './routes/workspace/$workspaceId/room/$roomId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AttributionRoute = AttributionRouteImport.update({
            id: '/attribution',path: '/attribution',getParentRoute: () => rootRouteImport
          })
const BenchmarkRoute = BenchmarkRouteImport.update({
            id: '/benchmark',path: '/benchmark',getParentRoute: () => rootRouteImport
          })
const CampusRoute = CampusRouteImport.update({
            id: '/campus',path: '/campus',getParentRoute: () => rootRouteImport
          })
const CliAuthRoute = CliAuthRouteImport.update({
            id: '/cli-auth',path: '/cli-auth',getParentRoute: () => rootRouteImport
          })
const CoachingRoute = CoachingRouteImport.update({
            id: '/coaching',path: '/coaching',getParentRoute: () => rootRouteImport
          })
const ConsultingRoute = ConsultingRouteImport.update({
            id: '/consulting',path: '/consulting',getParentRoute: () => rootRouteImport
          })
const DesignRoomRoute = DesignRoomRouteImport.update({
            id: '/design-room',path: '/design-room',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const FacilitatorRoute = FacilitatorRouteImport.update({
            id: '/facilitator',path: '/facilitator',getParentRoute: () => rootRouteImport
          })
const FeedbackRoute = FeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => rootRouteImport
          })
const HomeRoute = HomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => rootRouteImport
          })
const InboxRoute = InboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => rootRouteImport
          })
const IntegrationsRoute = IntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => rootRouteImport
          })
const MarketingRoute = MarketingRouteImport.update({
            id: '/marketing',path: '/marketing',getParentRoute: () => rootRouteImport
          })
const MulaiRoute = MulaiRouteImport.update({
            id: '/mulai',path: '/mulai',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const OtomatisRoute = OtomatisRouteImport.update({
            id: '/otomatis',path: '/otomatis',getParentRoute: () => rootRouteImport
          })
const PlanRoute = PlanRouteImport.update({
            id: '/plan',path: '/plan',getParentRoute: () => rootRouteImport
          })
const PlaybooksRoute = PlaybooksRouteImport.update({
            id: '/playbooks',path: '/playbooks',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PromptsRoute = PromptsRouteImport.update({
            id: '/prompts',path: '/prompts',getParentRoute: () => rootRouteImport
          })
const ReadinessRoute = ReadinessRouteImport.update({
            id: '/readiness',path: '/readiness',getParentRoute: () => rootRouteImport
          })
const RoomRoute = RoomRouteImport.update({
            id: '/room',path: '/room',getParentRoute: () => rootRouteImport
          })
const ServeRoute = ServeRouteImport.update({
            id: '/serve',path: '/serve',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const StudioRoute = StudioRouteImport.update({
            id: '/studio',path: '/studio',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ToolsRoute = ToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => rootRouteImport
          })
const TransactionsRoute = TransactionsRouteImport.update({
            id: '/transactions',path: '/transactions',getParentRoute: () => rootRouteImport
          })
const VouchersRoute = VouchersRouteImport.update({
            id: '/vouchers',path: '/vouchers',getParentRoute: () => rootRouteImport
          })
const ToolIdEditRoute = ToolIdEditRouteImport.update({
            id: '/$toolId/edit',path: '/$toolId/edit',getParentRoute: () => rootRouteImport
          })
const AdminCampusRoute = AdminCampusRouteImport.update({
            id: '/admin/campus',path: '/admin/campus',getParentRoute: () => rootRouteImport
          })
const AdminChatRoute = AdminChatRouteImport.update({
            id: '/admin/chat',path: '/admin/chat',getParentRoute: () => rootRouteImport
          })
const AdminDashboardRoute = AdminDashboardRouteImport.update({
            id: '/admin/dashboard',path: '/admin/dashboard',getParentRoute: () => rootRouteImport
          })
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
            id: '/admin/feedback',path: '/admin/feedback',getParentRoute: () => rootRouteImport
          })
const AdminPlansRoute = AdminPlansRouteImport.update({
            id: '/admin/plans',path: '/admin/plans',getParentRoute: () => rootRouteImport
          })
const AdminTinjauanRoute = AdminTinjauanRouteImport.update({
            id: '/admin/tinjauan',path: '/admin/tinjauan',getParentRoute: () => rootRouteImport
          })
const AdminToolsRoute = AdminToolsRouteImport.update({
            id: '/admin/tools',path: '/admin/tools',getParentRoute: () => rootRouteImport
          })
const AdminTransactionsRoute = AdminTransactionsRouteImport.update({
            id: '/admin/transactions',path: '/admin/transactions',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => rootRouteImport
          })
const AdminVouchersRoute = AdminVouchersRouteImport.update({
            id: '/admin/vouchers',path: '/admin/vouchers',getParentRoute: () => rootRouteImport
          })
const ClientIndexRoute = ClientIndexRouteImport.update({
            id: '/client/',path: '/client/',getParentRoute: () => rootRouteImport
          })
const ClientPlanIdRoute = ClientPlanIdRouteImport.update({
            id: '/client/$planId',path: '/client/$planId',getParentRoute: () => rootRouteImport
          })
const CompareSlugRoute = CompareSlugRouteImport.update({
            id: '/compare/$slug',path: '/compare/$slug',getParentRoute: () => rootRouteImport
          })
const InviteTokenRoute = InviteTokenRouteImport.update({
            id: '/invite/$token',path: '/invite/$token',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const PlansPlanIdRoute = PlansPlanIdRouteImport.update({
            id: '/plans/$planId',path: '/plans/$planId',getParentRoute: () => rootRouteImport
          })
const RTokenRoute = RTokenRouteImport.update({
            id: '/r/$token',path: '/r/$token',getParentRoute: () => rootRouteImport
          })
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
            id: '/templates/',path: '/templates/',getParentRoute: () => rootRouteImport
          })
const TemplatesSlugRoute = TemplatesSlugRouteImport.update({
            id: '/templates/$slug',path: '/templates/$slug',getParentRoute: () => rootRouteImport
          })
const WorkspaceWorkspaceIdIndexRoute = WorkspaceWorkspaceIdIndexRouteImport.update({
            id: '/workspace/$workspaceId/',path: '/workspace/$workspaceId/',getParentRoute: () => rootRouteImport
          })
const WorkspaceWorkspaceIdViewRoute = WorkspaceWorkspaceIdViewRouteImport.update({
            id: '/workspace/$workspaceId/$view',path: '/workspace/$workspaceId/$view',getParentRoute: () => rootRouteImport
          })
const WorkspaceWorkspaceIdBangunRoute = WorkspaceWorkspaceIdBangunRouteImport.update({
            id: '/workspace/$workspaceId/bangun',path: '/workspace/$workspaceId/bangun',getParentRoute: () => rootRouteImport
          })
const WorkspaceWorkspaceIdBantuanRoute = WorkspaceWorkspaceIdBantuanRouteImport.update({
            id: '/workspace/$workspaceId/bantuan',path: '/workspace/$workspaceId/bantuan',getParentRoute: () => rootRouteImport
          })
const WorkspaceWorkspaceIdCostRoute = WorkspaceWorkspaceIdCostRouteImport.update({
            id: '/workspace/$workspaceId/cost',path: '/workspace/$workspaceId/cost',getParentRoute: () => rootRouteImport
          })
const WorkspaceWorkspaceIdSettingsRoute = WorkspaceWorkspaceIdSettingsRouteImport.update({
            id: '/workspace/$workspaceId/settings',path: '/workspace/$workspaceId/settings',getParentRoute: () => rootRouteImport
          })
const WorkspaceWorkspaceIdStudioRoute = WorkspaceWorkspaceIdStudioRouteImport.update({
            id: '/workspace/$workspaceId/studio',path: '/workspace/$workspaceId/studio',getParentRoute: () => rootRouteImport
          })
const WorkspaceWorkspaceIdTerbitkanRoute = WorkspaceWorkspaceIdTerbitkanRouteImport.update({
            id: '/workspace/$workspaceId/terbitkan',path: '/workspace/$workspaceId/terbitkan',getParentRoute: () => rootRouteImport
          })
const WorkspaceWorkspaceIdRoomIndexRoute = WorkspaceWorkspaceIdRoomIndexRouteImport.update({
            id: '/workspace/$workspaceId/room/',path: '/workspace/$workspaceId/room/',getParentRoute: () => rootRouteImport
          })
const WorkspaceWorkspaceIdRoomRoomIdRoute = WorkspaceWorkspaceIdRoomRoomIdRouteImport.update({
            id: '/workspace/$workspaceId/room/$roomId',path: '/workspace/$workspaceId/room/$roomId',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AttributionRoute: AttributionRoute,BenchmarkRoute: BenchmarkRoute,CampusRoute: CampusRoute,CliAuthRoute: CliAuthRoute,CoachingRoute: CoachingRoute,ConsultingRoute: ConsultingRoute,DesignRoomRoute: DesignRoomRoute,DocsRoute: DocsRoute,FacilitatorRoute: FacilitatorRoute,FeedbackRoute: FeedbackRoute,HomeRoute: HomeRoute,InboxRoute: InboxRoute,IntegrationsRoute: IntegrationsRoute,MarketingRoute: MarketingRoute,MulaiRoute: MulaiRoute,OnboardingRoute: OnboardingRoute,OtomatisRoute: OtomatisRoute,PlanRoute: PlanRoute,PlaybooksRoute: PlaybooksRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,PromptsRoute: PromptsRoute,ReadinessRoute: ReadinessRoute,RoomRoute: RoomRoute,ServeRoute: ServeRoute,SettingsRoute: SettingsRoute,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,StudioRoute: StudioRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,ToolsRoute: ToolsRoute,TransactionsRoute: TransactionsRoute,VouchersRoute: VouchersRoute,ToolIdEditRoute: ToolIdEditRoute,AdminCampusRoute: AdminCampusRoute,AdminChatRoute: AdminChatRoute,AdminDashboardRoute: AdminDashboardRoute,AdminFeedbackRoute: AdminFeedbackRoute,AdminPlansRoute: AdminPlansRoute,AdminTinjauanRoute: AdminTinjauanRoute,AdminToolsRoute: AdminToolsRoute,AdminTransactionsRoute: AdminTransactionsRoute,AdminUsersRoute: AdminUsersRoute,AdminVouchersRoute: AdminVouchersRoute,ClientPlanIdRoute: ClientPlanIdRoute,CompareSlugRoute: CompareSlugRoute,InviteTokenRoute: InviteTokenRoute,PSlugRoute: PSlugRoute,PlansPlanIdRoute: PlansPlanIdRoute,RTokenRoute: RTokenRoute,TemplatesSlugRoute: TemplatesSlugRoute,ClientIndexRoute: ClientIndexRoute,TemplatesIndexRoute: TemplatesIndexRoute,WorkspaceWorkspaceIdViewRoute: WorkspaceWorkspaceIdViewRoute,WorkspaceWorkspaceIdBangunRoute: WorkspaceWorkspaceIdBangunRoute,WorkspaceWorkspaceIdBantuanRoute: WorkspaceWorkspaceIdBantuanRoute,WorkspaceWorkspaceIdCostRoute: WorkspaceWorkspaceIdCostRoute,WorkspaceWorkspaceIdSettingsRoute: WorkspaceWorkspaceIdSettingsRoute,WorkspaceWorkspaceIdStudioRoute: WorkspaceWorkspaceIdStudioRoute,WorkspaceWorkspaceIdTerbitkanRoute: WorkspaceWorkspaceIdTerbitkanRoute,WorkspaceWorkspaceIdIndexRoute: WorkspaceWorkspaceIdIndexRoute,WorkspaceWorkspaceIdRoomRoomIdRoute: WorkspaceWorkspaceIdRoomRoomIdRoute,WorkspaceWorkspaceIdRoomIndexRoute: WorkspaceWorkspaceIdRoomIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)